// frontend/src/config/userGuideTranslations.js
//
// Translation overrides for the User Guide, keyed by locale → section id.
// English is the canonical source (see userGuideContent.js), so there is NO
// `en` entry here. Any string not translated falls back to English
// automatically, so a half-finished locale never shows blanks.
//
// ─────────────────────────────────────────────────────────────────────────
// HOW TO ADD A TRANSLATION (production process: MT draft + native review)
// ─────────────────────────────────────────────────────────────────────────
// 1. For each section you translate, add an entry under the locale code using
//    the SAME section `id` as in userGuideContent.js.
// 2. Mirror the block ORDER from userGuideContent.js. For each block you may
//    provide `heading`, `text`, and/or `items` (array, same order/length).
//    Omit any field/block you haven't translated — it falls back to English.
// 3. Keep fixed terms consistent (use the GLOSSARY below) so the same concept
//    is translated the same way everywhere.
// 4. Have a native speaker review the machine-translated draft BEFORE flipping
//    `ready: true` for that locale in userGuideLanguages.js.
//
// Shape:
//   {
//     bn: {
//       'getting-started': {
//         title: '…',
//         summary: '…',
//         blocks: [
//           { heading: '…', items: ['…', '…'] },   // matches blocks[0]
//           { text: '…' },                           // matches blocks[1]
//         ],
//       },
//       // …more sections
//     },
//   }
//
// ─────────────────────────────────────────────────────────────────────────
// GLOSSARY — translate these consistently across every locale
// ─────────────────────────────────────────────────────────────────────────
//   Clock In / Clock Out, Recovery Day, Off in Lieu (OIL), Annual Leave,
//   Unpaid Leave, Nightwork, Rest Day, Reporting Officer (RO), HOD,
//   Self-Service, Payslip, Acknowledge, Single Sign-On.
//
// Locale modules remain separate so HR can review and update one language
// without creating merge conflicts in a single very large file.

import { USER_GUIDE_TRANSLATIONS_BN } from './userGuideTranslations.bn';
import { USER_GUIDE_TRANSLATIONS_TA } from './userGuideTranslations.ta';
import { USER_GUIDE_TRANSLATIONS_MY } from './userGuideTranslations.my';

export const USER_GUIDE_TRANSLATIONS = {
  bn: USER_GUIDE_TRANSLATIONS_BN,
  ta: USER_GUIDE_TRANSLATIONS_TA,
  my: USER_GUIDE_TRANSLATIONS_MY,
};
